var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmoji20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web/Bold/20\\xD720/face.laughing",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 110 18 9 9 0 010-18zm0 1.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm-3 4c.552 0 1 .56 1 1.25S7.552 9 7 9s-1-.56-1-1.25.448-1.25 1-1.25zm6 0c.552 0 1 .56 1 1.25S13.552 9 13 9s-1-.56-1-1.25.448-1.25 1-1.25z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.75h9.5c-.5 2.333-2.083 3.5-4.75 3.5s-4.25-1.167-4.75-3.5z",
    id: "Rectangle",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fillOpacity: 0.3,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji20);
export default __webpack_public_path__ + "static/media/emoji-20.63b024ec.svg";
export { ForwardRef as ReactComponent };